<template>
    <div>
        <rkm-row class="flex-nowrap">

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Peso"
                    v-model="model.peso"
                    placeholder="000"
                    :mask="maskPeso"
                    :validations="validations.peso"
                    :disabled="isDisabledLimite() && !model.peso || isDisabledInformacoes(enums.procedimento.MEDICAO_DE_PESO)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            kg
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Altura"
                    v-model="model.altura"
                    :mask="maskAltura"
                    placeholder="000"
                    :validations="validations.altura"
                    :disabled="isDisabledLimite() && !model.altura || isDisabledInformacoes(enums.procedimento.MEDICAO_DE_ALTURA)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Aferição de PA"
                    v-model="model.afericaoPa"
                    placeholder="000/000"
                    v-mask="'###/###'"
                    :validations="validations.pressaoArterial"
                    :disabled="isDisabledLimite() && !model.afericaoPa || isDisabledInformacoes(enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mmHg
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Glicemia"
                    v-model="model.glicemia"
                    v-mask="'###'"
                    placeholder="000"
                    :validations="validations.glicemiaCapilar"
                    :disabled="isDisabledLimite() && !model.glicemia || isDisabledInformacoes(enums.procedimento.CLICEMIA_CAPILAR)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mg/dL
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Temperatura"
                    v-model="model.temperatura"
                    placeholder="00,0"
                    :mask="maskTemperatura"
                    :validations="validations.temperatura"
                    :disabled="isDisabledLimite() && !model.temperatura || isDisabledInformacoes(enums.procedimento.AFERICAO_DE_TEMPERATURA)"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            °C
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>

            <rkm-col cols="6">
                <rkm-form-checkbox
                    :label="false"
                    v-model="model.exameLaboratorial"
                    class="pt-0"
                    :disabled="isDisabledLimite() && !model.exameLaboratorial || isDisabledInformacoes(enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL)"
                >
                    Coleta de material para exame laboratorial
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
//Enums
import procedimento from '@/enums/sigtap/procedimento'
import limite from '@/enums/atencao-basica/procedimento/limite'

// Mixins.
import { repository, object, formats, stringCase, mask, data } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
                pressaoArterial: { max_value: 999 },
                glicemiaCapilar: { min_value: 0, max_value: 800 },
                temperatura: { min_value: 20, max_value: 45 },
            }
        },
        maskPeso() {

            const value = this.model && this.model.peso ? this.model.peso : null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 1) {
                        return '#.###';
                    } else if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '###';
        },
        maskAltura() {

            const value = this.model.altura ?? null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '###';
        },
        maskTemperatura() {

            return '##.#';
        },
    },
    methods: {
        isRequired() {

            return !this.model.escutaInicial
                && !this.model.peso
                && !this.model.altura
                && !this.model.afericao
                && !this.model.glicemia
                && !this.model.temperatura
                && !this.model.exameLaboratorial
                && this.model.procedimentoPequenaCirurgia.length === 0
                && this.model.testeRapido.length === 0
                && this.model.administracaoMedicamento.length === 0
                && this.model.procedimentos.length === 0
        },
        isDisabledLimite() {

            if (Object.keys(this.model).length > 0) {
                const limite = this.handleLimite()
                return limite >= this.enums.limite.QUANTIDADE ? true : false
            }

            return false
        },
        handleLimite() {

            const quantidadeEscutaInicial = this.model.escutaInicial ? 1 : 0

            const limite = quantidadeEscutaInicial
                + this.model.procedimentoPequenaCirurgia.length
                + this.model.testeRapido.length
                + this.model.administracaoMedicamento.length
                + this.model.procedimentos.length

            return limite
        },
        isDisabledInformacoes(codigo) {

        return this.data.model.procedimentoUsuario
            && this.data.model.procedimentoUsuario.find(procedimento => procedimento.codigo == codigo).isDisabled
        },
        addProcedimento(codigoProcedimento){

            const procedimento = this.data.form.procedimentos.find(procedimento =>
                procedimento.codigo == codigoProcedimento)
            const existe = this.model.procedimentos.find(procedimento => procedimento.codigo == codigoProcedimento)

            if (existe) {
                return false
            }

            const limite = this.handleLimite()

            if (limite >= this.enums.limite.QUANTIDADE) {
                this.showAlert('Foi atingido o limite de 20 procedimentos por ficha.', "Atenção")
                return false
            }

            if (procedimento) {

                const param = {
                    id: procedimento.id,
                    nome: procedimento.nome,
                    codigo: procedimento.codigo,
                }

                this.model.procedimentos.push(this.clone(param))
            }
        },
    },
    data: () => ({
        enums: {
            procedimento,
            limite,
        },
    }),
    mixins: [ repository, object, formats, stringCase, mask, data ],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.peso': function (peso) {

            if (peso) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)

                if (this.model.altura) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_PESO)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'model.altura': function (altura) {

            if (altura) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (this.model.peso) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'model.temperatura': function (febre) {

            if (febre) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AFERICAO_DE_TEMPERATURA)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
        'model.afericaoPa': function (afericao) {

            if (afericao) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
        'model.glicemia': function (glicemia) {

            if (glicemia) {
                this.addProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.GLICEMIA_CAPILAR)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
        'model.exameLaboratorial': function (exameLaboratorial) {

            if (exameLaboratorial) {
                this.addProcedimento(this.enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>